<template>
  <div>
    <Topbar title="Mot de passe" backButton />
    <section class="Section">
      <form @submit.prevent="reset" autocomplete="off">
        <div class="InputGroup">
          <label class="InputGroup__label">Mot de passe actuel</label>
          <PasswordInput :required="true" v-model="currentPassword" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Nouveau mot de passe</label>
          <PasswordInput :required="true" v-model="password" />
        </div>
        <div class="InputGroup">
          <label class="InputGroup__label">Nouveau mot de passe (vérification)</label>
          <PasswordInput :required="true" v-model="passwordConfirmation" />
        </div>
        <Button class="Button--primary" type="submit" :loading="loading">Confirmation</Button>
      </form>
    </section>
  </div>
</template>

<script>
import userService from "../services/user";
import notificationService from "../services/notification";
import PasswordInput from "../components/PasswordInput";

import Button from "../components/Button";

export default {
  data() {
    return {
      currentPassword: "",
      password: "",
      passwordConfirmation: "",
      loading: false
    };
  },
  methods: {
    reset: function() {
      this.loading = true;

      userService.resetPassword({
        "current_password": this.currentPassword,
        password: this.password,
        "password_confirmation": this.passwordConfirmation
      })
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "Profile" });
          notificationService.success("Votre modification a été prise en compte.");
        })
        .catch(err => {
          this.loading = false;
          notificationService.error(err.message, err.errors);
        });
    }
  },
  components: { PasswordInput, Button }
};
</script>

<style lang="scss" scoped>
@import '../assets/variables';

form {
  max-width: 22em;
}

@media (max-width: 900px) {
  .Button {
    width: 100%;
  }
}
</style>
